import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import CompleteLoad from '../modals/completeLoad';
import './loadheader.css';

export default class LoadHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerMenu: false,
            showPlaneLoadNumOnly: null,
        }

        this.thisRef = React.createRef();
    }
    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
        let m = window.ENV?.showPlaneLoadNumOnly;
        this.setState({ showPlaneLoadNumOnly: m })
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                headerMenu: false
            });
        }
    }
    toggleHeaderMenu = () => {
        this.setState({ headerMenu: !this.state.headerMenu })
    }
    handleCancelLoad = loadId => {
        document.getElementById(loadId).click();
        this.hideHeaderMenu()
    };

    handleUpdateLoad = loadId => {
        document.getElementById(loadId).click();
        this.hideHeaderMenu()
    };
    hideHeaderMenu = () => {
        this.setState({ headerMenu: false })
    }
    returnHeaderClasses = () => {
        let { loadObj } = this.props;
        let { showPlaneLoadNumOnly } = this.state;
        let text = "load-header"
        if (loadObj.gearUp) {
            text += " geared-up";
        }
        if (showPlaneLoadNumOnly) {
            text += " show-plane-left"
        }
        return text;
    }
    renderTopText = () => {
        let { loadObj, isCompleted } = this.props;
        let text = "OPEN";
        if (isCompleted) {
            text = 'COMPLETED';
        }
        else if (loadObj.isWaitlist) {
            text = "WAIT LIST"
        }
        else if (loadObj.inAir && loadObj.currentAltitude === 0) {
            text = "IN AIR"
        }
        else if (loadObj.inAir && loadObj.currentAltitude > 0) {
            text = loadObj.currentAltitude + " FT";
        }
        else if (loadObj.gearUp && loadObj.timeRemaining > 180) {
            text = "GEAR UP!"
        }
        else if (loadObj.gearUp && loadObj.timeRemaining <= 180) {
            text = "NOW!"
        }
        else {
            if (loadObj.closed) {
                text = "CLOSED"
            }
            else if (loadObj.isNext) {
                text = "NEXT " + loadObj.plane.toUpperCase()
            }
            else if (loadObj.totalJumpers < loadObj.capacity) {
                text = "OPEN"
            }
            else if (loadObj.totalJumpers >= loadObj.capacity) {
                text = "FULL"
            }
        }

        return text;
    }
    renderRedText = () => {
        let { loadObj } = this.props;

        let text = null;
        if (loadObj.waitFuel) {
            text = "FUEL BEFORE"
        }
        return <p className="red-text">{text}</p>

    }
    renderStartupText = () => {
        let { loadObj } = this.props;

        let text = null;
        if (loadObj.isStartup) {
            text = "STARTUP"
        }
        return <p className="green-text">{text}</p>

    }
    renderBottomText = () => {
        let { loadObj } = this.props;
        //console.log("loadObj==>", loadObj)
        let text = null;
        if (loadObj.reserved) {
            text = "RESERVED"
        }
        // if (loadObj.isWaitlist && loadObj.totalJumpers >= loadObj.capacity) {
        if (loadObj.totalJumpers >= loadObj.capacity && loadObj.isNext) {
            text = "FULL"
        }
        return <p className="bottom-text">{text}</p>
    }
    renderLoadingArea = () => {
        let { loadObj } = this.props;

        let text = "";

        if(loadObj.loadingArea){
            return <p className="loadingarea-text">{loadObj.loadingArea}</p>
        }

    }

    renderplanesfun=()=>{
        let { loadObj } = this.props;
        let { showPlaneLoadNumOnly } = this.state;
        
        if(this.props.loadsToShow < 5)
        return(
        <div className="second show-plane-name-left" >
            <div style={this.props.loadsToShow===4 && loadObj.plane.length>7?{fontSize:"28px",height:"45px"}:{height:"45px"}}>
                {loadObj.plane.slice(0, 16).toUpperCase()}
            </div>
            <div>{loadObj.planeLoadNum}</div>
        </div>)
        else if(this.props.loadsToShow==5){
            return(
        <div className="second show-plane-name-left" >
            <div style={this.props.loadsToShow>4 && loadObj.plane.length>7?{fontSize:"24px",height:"42px"}:{height:"43px"}}>
                {loadObj.plane.slice(0, 16).toUpperCase()}
            </div>
            <div>{loadObj.planeLoadNum}</div>
        </div>)
        }
        else if(this.props.loadsToShow==6){
            return(
        <div className="second show-plane-name-left" >
            <div style={this.props.loadsToShow>4 && loadObj.plane.length>7?{fontSize:"21px",height:"38px"}:{height:"40px"}}>
                {loadObj.plane.slice(0, 16).toUpperCase()}
            </div>
            <div>{loadObj.planeLoadNum}</div>
        </div>)
        }
    }

    renderPlanes = () => {
        let { loadObj } = this.props;
        let { showPlaneLoadNumOnly } = this.state;
        {console.log(loadObj.plane.length,this.props.loadsToShow,"<<<<<<<<check your values")}
        return <React.Fragment>

            {showPlaneLoadNumOnly? 
            this.renderplanesfun()
            :<div className="second">
                {loadObj.plane.slice(0, 16).toUpperCase()}-{loadObj.planeLoadNum}
            </div>}
           


            {!showPlaneLoadNumOnly ? <div className="third d-flex">
                <p className="small-skydiver"></p>
                <p>
                    {loadObj.totalJumpers}/ {loadObj.capacity}
                </p>
            </div>
                : null}
        </React.Fragment>
    }
    renderSlotRemaining = () => {
        let { loadObj } = this.props;
        return <div className="slots">
            <p>{loadObj.capacity - loadObj.totalJumpers} left</p>
        </div>
    }
    renderLoadNumber = () => {
        let { loadObj } = this.props;
        return <p className="load-no">
            {/* <EditableTimer
                            timeRemaining={loadObj.loadNum}
                            loadNum={loadObj.loadNum}
                            isPause={loadObj.isPaused}
                            type="loadNum"
                        /> */}
            {loadObj.loadNum}
        </p>
    }
    render() {
        let { loadObj } = this.props;
        let { headerMenu, showPlaneLoadNumOnly } = this.state;

        //console.log('rendering load header');
        // //console.log("🚀 ~ file:LoadHeader ~ render ~ loadObj", loadObj)
        var text = this.renderTopText()
        return (
            <div className={this.returnHeaderClasses()} >
                <div className={showPlaneLoadNumOnly ? "left-side-width left-side":"left-side"} style={text === "COMPLETED" ? { color: "white" } : { color: loadObj.planeColor }}>
                    {showPlaneLoadNumOnly ? this.renderPlanes() : this.renderLoadNumber()}

                </div>

                <div className={loadObj.gearUp ? "middle-side fe-pulse" : "middle-side"}>
                    <span style={{ color: loadObj.planeColor }}><p className="top-text">{this.renderTopText()}</p>
                    </span>
                    {this.renderRedText()}
                    {this.renderStartupText()}
                    {this.renderBottomText()}
                    {this.renderLoadingArea()}
                </div>

                <div className="right-side">
                    <div className="first">
                        <p className="plane-img"></p>
                        <button onClick={this.toggleHeaderMenu}>
                            <i className="fa fa-ellipsis-v"></i>
                        </button>
                    </div>
                    {showPlaneLoadNumOnly ? this.renderSlotRemaining() : this.renderPlanes()}

                </div>

                {headerMenu && localStorage.getItem("role") === "pilot" && (
                    <CompleteLoad ref={this.thisRef} onClickBtn={() => this.setState({ headerMenu: false })} load={this.props.loadObj} />
                )}
            </div>

        )
    }
}
